import { getCurrentLanguage } from "/Assets/js/common/utilities.js";

// ========================================
// TRANSLATIONS LOADER
// ========================================

// Module-level singleton — one fetch per page, shared across all importers.
let translationsPromise = null;

/**
 * Lazily fetches and caches the jsl10n translations JSON for the current language.
 * Safe to call from multiple files — the fetch only happens once.
 * @returns {Promise<object>} Resolves to the translations object (same shape as window.jsl10n)
 */
export function getTranslations() {
    if (!translationsPromise) {
        const lang = getCurrentLanguage("en");
        translationsPromise = fetch(`/jsl10n/JsResources?lang=${lang}&json=true`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Failed to load translations (${response.status})`);
                }
                return response.json();
            });

        // Don't permanently cache rejections — allows retry on next call
        translationsPromise.catch(() => {
            translationsPromise = null;
        });
    }

    return translationsPromise;
}